// removed by extract-text-webpack-plugin
module.exports = {"popover":"antd-pro-notice-icon-popover","noticeButton":"antd-pro-notice-icon-noticeButton","icon":"antd-pro-notice-icon-icon","badge":"antd-pro-notice-icon-badge","tabs":"antd-pro-notice-icon-tabs"};


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/src/components/NoticeIcon/index.less
// module id = 1136
// module chunks = 0